export default "__VITE_ASSET__XnAa9waD__"